import { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import { checkWBToken } from "../../ApiService";
import { FormikErrors } from "formik";

function useTokenValidation(
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<unknown>>
) {
  const [isTokenEditing, setIsTokenEditing] = useState(false);
  const [isTokenValid, setTokenValid] = useState(false);

  const debouncedCheckToken = useCallback(
    debounce((value) => {
      checkWBToken(value)
        .then(({ valid }) => {
          setTokenValid(valid);
        })
        .catch((error) => {
          console.error("Error checking WB token:", error);
          setTokenValid(false);
        });
    }, 500),
    []
  );

  const handleTokenChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("token", e.target.value);
    debouncedCheckToken(e.target.value);
  };

  const setEditChecked = () => {
    setIsTokenEditing((prev) => {
      if (!prev === false) {
        setTokenValid(false);
        setFieldValue("token", "");
      }
      return !prev;
    });
  };

  useEffect(() => {
    return () => {
      debouncedCheckToken.cancel();
    };
  }, [debouncedCheckToken]);

  return {
    isTokenEditing,
    isTokenValid,
    setIsTokenEditing,
    handleTokenChange,
    setTokenValid,
    setEditChecked,
  };
}

export default useTokenValidation;
